var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.327 9.058v-1.5H20.5v1.5zm0 3.692v-1.5H20.5v1.5zm0 3.692v-1.5H20.5v1.5zm-3.02-7.326a.796.796 0 0 1-.808-.818q.001-.338.233-.569a.79.79 0 0 1 .576-.229.786.786 0 0 1 .808.798.796.796 0 0 1-.808.818m0 3.682a.79.79 0 0 1-.575-.23A.77.77 0 0 1 3.5 12a.79.79 0 0 1 .808-.817q.343 0 .575.23a.8.8 0 0 1 .232.587.77.77 0 0 1-.232.569.79.79 0 0 1-.575.229m0 3.702a.796.796 0 0 1-.808-.817q.001-.34.233-.569a.79.79 0 0 1 .576-.23.786.786 0 0 1 .808.799.796.796 0 0 1-.808.817"
  })));
};
export default SvgList;